import Axios from 'axios';
import { async } from 'q';
import Cookies from 'js-cookie';

// if (!Cookies.get("auth-token")) {
//   Cookies.set("auth-token", "eyJpdiI6Ik9EdTJZZEUzWnhPb25kZExQMzFmcGc9PSIsInZhbHVlIjoidDhQQjhPXC9sQ3N3TkYwNFBqakw2NUE9PSIsIm1hYyI6ImFkOTNjZjY1YzAzMzVkYzVjYWQ5ZTAzNmIxODNlZTU0YTU4Y2FkYmIwODA3NzQ3MzZlZDY2N2RjYTJkOTBiNDcifQ==");
// }

let authToken = Cookies.get("auth-token");
const apiUrl = process.env.VUE_APP_API_URL;
// console.log("authToken", authToken);
export default {

  refreshToken: function () {
    authToken = Cookies.get("auth-token");
  },

  activityEvents: async () => {
    return await get("/activity_events");
  },

  markNotificationsAsRead: async () => {
    return await post("/activity_events/mark_as_read");
  },

  book: async (id) => {
    return await get("/books/" + id);
  },

  books: async () => {
    return await get("/books");
  },

  saveBook: async (book) => {
    return await post("/books", book)
  },

  submitBook: async (book) => {
    return await post("/books/" + book.id + "/submit");
  },

  upBook: async (book, upgrades) => {
    return await post("/books/" + book.id + "/up", upgrades);
  },

  trashBook: async (book) => {
    return await get("/books/" + book.id + "/trash");
  },

  changeRequest: async (assignment, upgrades) => {
    return await post("/assignments/change_request", { 'assignment_id': assignment.id, ...upgrades });
  },

  saveAuthorMessage: async (book, authorMessage) => {
    return await post("/books/" + book.id + "/author_message", { author_message: authorMessage });
  },

  genres: async () => {
    return await get("/genres");
  },

  languages: async () => {
    return await get("/languages");
  },

  getReviewIssues: async () => {
    return await get("/issues");
  },

  assignment: async (id) => {
    return await get("/assignments/" + id);
  },

  assignments: async (params) => {
    return await get("/assignments", params);
  },

  recommend: async (filters) => {
    return await get("/assignments/recommend", filters);
  },

  refreshRecommendations: async () => {
    return await get("/assignments/recommend/refresh");
  },

  startAssignment: async (assignmentId, rewardType) => {
    return await post("/assignments/start", { assignment_id: assignmentId, reward_type: rewardType })
  },

  saveAssignment: async (assignment) => {
    return await post("/assignments", assignment);
  },

  reportAssignmentIssue: async (params) => {
    return await post("/assignments/issue", params);
  },

  cancelAssignment: async (assignment) => {
    return await post("/assignments/cancel", { assignment_id: assignment.id });
  },

  cancelReview: async (assignment) => {
    return await post("/assignments/cancel_review", { assignment_id: assignment.id });
  },

  turnInReview: async (assignment, rating, amazonUsername, countryCode) => {
    return await post("/assignments/turn_in", {
      assignment_id: assignment.id,
      rating: rating,
      amazonUsername: amazonUsername,
      countryCode: countryCode,
    });
  },

  submitReviewLink: async (params) => {
    return await post("/assignments/submit_link", params);
  },

  reconcileReview: async (params) => {
    return await post("/assignments/submit_link/approve", params);
  },

  user: async () => {
    return await get("/users/handshake");
  },

  signIn: async (username, password) => {
    return await post("/users/sign_in", { 'email': username, 'password': password });
  },

  coverUploadUrl: (book) => {
    return apiUrl + "/files/covers";
  },

  manuscriptUploadUrl: (book) => {
    return apiUrl + "/files/manuscripts";
  },

  downloadManuscript: async (assignment) => {

    Axios.get(apiUrl + "/assignments/" + assignment.id + "/download-manuscript/" + (isIos() ? "1" : "0"),
      {
        responseType: 'arraybuffer',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/pdf',
          "X-Auth-Token": authToken
        }
      })
      .then((response) => {
        // console.log('downloadManuscript', response.headers['content-type'], response);
        let fileExtension = null;
        if (response.headers['content-type'] === 'application/xhtml+xml' || response.headers['content-type'] === 'application/epub+zip') {
          fileExtension = '.epub';
        } else {
          fileExtension = '.pdf';
        }
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', assignment.book.title + fileExtension); //or any other extension
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => console.log(error));

    //return await get("/assignments/" + assignment.id + "/download-manuscript", null, true);
  },

  downloadBookManuscript: async (book) => {

    Axios.get(apiUrl + "/books/" + book.id + "/download-manuscript/" + (isIos() ? "1" : "0"),
      {
        responseType: 'arraybuffer',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/pdf',
          "X-Auth-Token": authToken
        }
      })
      .then((response) => {
        console.log('downloadManuscript', response.headers['content-type'], response);
        let fileExtension = null;
        if (response.headers['content-type'] === 'application/xhtml+xml' || response.headers['content-type'] === 'application/epub+zip') {
          fileExtension = '.epub';
        } else {
          fileExtension = '.pdf';
        }
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', book.title + fileExtension); //or any other extension
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => console.log(error));

    //return await get("/assignments/" + assignment.id + "/download-manuscript", null, true);
  },

  tweets: async () => {
    return await get("/social/tweets");
  },

  recommendTweets: async () => {
    return await get("/social/tweets/recommend");
  },

  addPaidTweet: async (url) => {
    return await post("/social/tweets/paid", {
      url
    });
  },

  upPaidTweet: async (tweetId) => {
    return await post("/social/tweets/up-paid/" + tweetId);
  },

  addTweet: async (url, likesBudget, retweetsBudget) => {
    return await post("/social/tweets", {
      url, likesBudget, retweetsBudget
    });
  },

  likeTweet: async (tweetId) => {
    return await post("/social/likes", {
      'tweet_id': tweetId
    });
  },

  retweetTweet: async (tweetId) => {
    return await post("/social/retweets", {
      'tweet_id': tweetId
    });
  },

  userPaymentMethod: async () => {
    return await get('/users/payment_method');
  },

  userPlaceOrder: async (sku) => {
    return await post('/users/place_order', {
      'sku': sku
    });
  },

  userNextSnapPackDate: async () => {
    return await get('/users/next_snap_pack_date');
  },

  assistantReview: async (id) => {
    return await get('/assistant_reviews/' + id);
  },

  requestAssistantReview: async (assignment) => {
    return await post('/assistant_reviews', {
      'assignment_id': assignment.id
    });
  },

  saveTweet: async (tweet) => {
    return await post("/social/tweets", tweet);
  },

  requestTwitterAccessToken: async () => {
    return await get("/social/access/token");
  },

  saveReferOption: async (value) => {
    return await post("/users/save_refer_option", { 'value': value });
  },

  enableGrabYourFans: async () => {
    return await post("/users/enable_grab_your_fans");
  },

  submitPublishJob: async (job) => {
    return await post("/publish/jobs", job);
  },

  publishServices: async () => {
    return await get("/publish/services");
  },
  publishService: async (name) => {
    return await get("/publish/services/" + name);
  },
  publishJobs: async () => {
    return await get("/publish/jobs");
  },

  friendsReport: async () => {
    return await get("/friends/report");
  },
  
  removeFriend: async (name) => {
    return await post("/friends/remove" , {'name': name});
  },

  givePrize: async (assignmentId, compliments) => {
    return await post("/assignments/give_prize",
      {
        'assignment_id': assignmentId,
        'compliments': compliments
      });
  },

  reportReviewIssue: async (params) => {
    return await post("/assignments/report_issue", params);
  },

  reportActionTaken: async (id) => {
    return await post("/assignments/report_issue/" + id + "/action_taken")
  },

  getReviewIssue: async (assignmentId) => {
    return await get("/assignments/" + assignmentId + "/report_issue");
  },

  exitHeadsDown: async () => {
    return await post("/users/exit_heads_down",
      {});
  },

  getAmazonDomains: async (params) => {
    return await get("/data/getAmazonDomains", params);
  },

  getFrontendSettings: async (params) => {
    return await get("/data/getFrontendSettings", params);
  },

};

async function get(url, params, raw) {
  try {
    const response = await Axios.get(apiUrl + url, { headers: headers(), params });
    if (raw) {
      return response;
    }
    // console.log('response', response, response.data);
    return readResponse(response);
  } catch (err) {
    console.log('err', err);
    return false;
  }
}

async function put(url, resource) {

}

async function post(url, resource) {
  try {
    // console.log('resource', resource);
    const response = await Axios.post(apiUrl + url, resource, { headers: headers() });
    // console.log('response', response);
    return readResponse(response);
  } catch (err) {
    console.log('err', err);
    return false;
  }
}

function readResponse(response) {
  const { data } = response;



  if (data.success !== true) {

    // DEBT: Allow Stripe orders to pass through
    if (data.id && data.status === "paid") {
      return data;
    }

    return false;
  }

  return data.data;
}

function headers() {
  return {
    "X-Auth-Token": Cookies.get("auth-token")
  };
}

function isIos() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};